import { createSignal, createEffect, For } from "solid-js";

import { plotsToRanges, parsePlotRanges } from "~/lib";
import complianceMethods from "~/data/compliance.json";
import typesOfWorks from "~/data/worksType.json";
type WorksTypeKey = keyof typeof typesOfWorks;
type ComplianceMethodKey = keyof typeof complianceMethods;

export const PlotRangeSelector = ( props ) => {
	const [maxPlot] = createSignal( props.maxPlots );
	const [input, setInput] = createSignal( plotsToRanges( props.selectedPlots ?? [] ) );
	const [plots, setPlots] = createSignal( ...[props.selectedPlots ?? []] );
	const [errors, setErrors] = createSignal( [] );

	// Parse input whenever it changes
	createEffect( () => {
		const { plots, errors } = parsePlotRanges( input(), maxPlot() );
		setPlots( plots );
		setErrors( errors );
		props.onChange?.( plots );
	} );

	// Handle checkbox toggle
	const togglePlot = n => {
		console.log( plots() );
		
		const current = new Set( plots() );
		current.has( n ) ? current.delete( n ) : current.add( n );
		
		const updated: number[] = Array.from(current);
		updated.sort((a, b) => a - b);		

		setPlots( updated );
		setInput( plotsToRanges( updated ) );

		const selected = updated.map( i => props.plotData[i - 1] ).filter( Boolean );
		const uniqueWorksTypes = [...new Set( selected.map( x => x.worksType as WorksTypeKey ) )];
		const uniqueComplianceMethods = [...new Set( selected.map( x => x.complianceMethod as ComplianceMethodKey ) )];

		props.save( "meta", "plots", updated );
		
		props.save( "meta", {
			typeOfWorks: uniqueWorksTypes.map( t => typesOfWorks[t] ).join( ", " ),
			complianceMethods: uniqueComplianceMethods.map( c => complianceMethods[c] ).join( ", " )
		} );
	};

	return (
		<div class="space-y-3">
			<label class="block text-sm font-medium text-gray-700">
				Select plots by typing in a range*, or click desired plots manually. <span class="text-xs italic ml-2">* use commas to separate ranges</span>
			</label>

			<input
				class="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-300"
				type="text"
				placeholder="e.g. 1-20, 23, 30-45"
				value={input()}
				onInput={e => setInput( e.target.value )}
			/>

			<div class="grid grid-cols-10 gap-1">
				<For each={Array.from( { length: maxPlot() } )}>
					{( _, i ) => {
						const n = i() + 1;
						return (
							<button
								type="button"
								class={`border rounded text-center py-1 text-sm select-none ${plots().includes( n )
									? "bg-blue-500 text-white"
									: "hover:bg-blue-100"
									}`}
								onClick={() => togglePlot( n )}
							>
								{n}
							</button>
						);
					}}
				</For>
			</div>

			<div class="text-sm text-gray-700">
				{plots().length > 0 && (
					<p>
						<strong>{plots().length}</strong> plots selected:{" "}
						{plots().join( ", " )}
					</p>
				)}
			</div>

			{errors().length > 0 && (
				<ul class="text-sm text-red-600 list-disc list-inside">
					{errors().map( err => (
						<li>{err}</li>
					) )}
				</ul>
			)}
		</div>
	);
}


const Domestic = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentcolor" d="M320 64L320 188.6L464 304.9L464 415.8L432 415.8L432 576L640 576L640 64L320 64zM440.2 224L384 178.6L384 160L448 160L448 224L440.2 224zM576 160L576 224L512 224L512 160L576 160zM528 288L576 288L576 352L528 352L528 288zM576 416L576 480L512 480L512 416L576 416zM384 368L416 368L416 328L208 160L0 328L0 368L32 368L32 576L384 576L384 368zM256 336L256 432L160 432L160 336L256 336z" /></svg>

const NonDomestic = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="currentcolor" d="M80 96L64 96L64 544L576 544L576 166.6L553.1 177.6L400 251.1L400 166.2L376.8 177.8L224 254.2L224 96.1L80 96.1zM96 320L96 128L192 128L192 305.9L215.2 294.3L368 217.9L368 301.9L390.9 290.9L544 217.4L544 512L96 512L96 320zM160 368L144 368L144 464L240 464L240 368L160 368zM176 432L176 400L208 400L208 432L176 432zM272 368L272 464L368 464L368 368L272 368zM304 400L336 400L336 432L304 432L304 400zM416 368L400 368L400 464L496 464L496 368L416 368zM432 432L432 400L464 400L464 432L432 432z" /></svg>